import React from 'react';
import { usePresence } from '../app-hooks';
import { useSelector } from '../hook-utils';
import { Presence } from '../model';
import { selectMyAccess, selectMyself } from '../store/reducers/config';
import { selectExtension } from '../store/reducers/queueAgents';
import { ReactComponent as CheckIcon } from './icons/menu-check.svg';
import { ReactComponent as SettingsIcon } from './icons/toolbar-settings.svg';
import { MenuDivider, MenuItem, SubMenu } from './Menu';
import './PresenceButton.scss';
import PresenceIcon from './PresenceIcon';
import SplitButton from './SplitButton';

export default function PresenceButton({ onMore, onSettings, text }: { onMore?(): void, onSettings?(): void, text: boolean }) {
  const myself = useSelector(selectMyself)
  const access = useSelector(selectMyAccess)
  const extension = useSelector(s => myself && selectExtension(s, myself))
  const { presence } = usePresence(myself)

  const items = PresenceMenu()

  function onPresenceMore() {
    if (!myself || !onMore) { return }
    onMore()
  }

  function onPresenceSettings() {
    if (!myself || !onSettings) { return }
    onSettings()
  }

  const settings = access && access.features.extensionMyLocationSettings && onSettings && <MenuItem key='settings' onClick={onPresenceSettings}>
    <SettingsIcon />
    Settings
</MenuItem>

  const more = onMore && <MenuItem noIcon key='more' onClick={onPresenceMore}>More...</MenuItem>

  return <SplitButton title='Set your presence' className='PresenceButton' onClick={onPresenceMore} items={
    [settings,
      settings !== undefined && <MenuDivider key='d1' />,
      ...items,
      more !== undefined && <MenuDivider key='d2' />,
      more,
    ]}>
    {<PresenceIcon presence={presence.presence} deviceGroupType={presence.type} awayFromDesk={extension?.awayFromDesk} className='icon' />}
    {text && 'Presence'}
  </SplitButton>
}

export function PresenceMenu() {
  const myself = useSelector(selectMyself)
  const { presenceValues, breakCodes, presence, setPresence, extendedAvailable } = usePresence(myself)

  const extendedMenu = extendedAvailable && <SubMenu>{extendedAvailable.map(p => <MenuItem key={p.type} onClick={() => setPresence(Presence.Available, p.type)}>
    <PresenceIcon presence={Presence.Available} deviceGroupType={p.type} />
    {p.name}
  </MenuItem>)}</SubMenu>

  const breakMenu = breakCodes && <SubMenu>{breakCodes.map(b => <MenuItem key={b.id}
    onClick={() => setPresence(Presence.Break, undefined, b.id)}
    noIcon={!isBreak(b.id)}>
    {isBreak(b.id) && <CheckIcon />}
    {b.name}
  </MenuItem>)}</SubMenu>

  const items = presenceValues.map(p => <MenuItem key={p.presence}
    onClick={() => setPresence(p.presence)}
    subMenu={
      p.presence === Presence.Available ? extendedMenu :
        p.presence === Presence.Break ? breakMenu :
          undefined}>
    <PresenceIcon presence={p.presence} />
    {p.name}
  </MenuItem>)
  return items

  function isBreak(breakCode: number) {
    return presence.presence === Presence.Break && presence.breakCode === breakCode
  }
}
